module.exports = __webpack_public_path__ + "static/media/ebintBlackText.79d7286b.png";